<template>

  <Toast :group="page.name" position="bottom-center" />
  <Loader v-if="loader" />


  <div class="page">
    <p>I seguenti documenti saranno accessibili a TUTTI gli agenti</p>

      <div class="formgrid grid form-file">
      <div class="field col-12 md:col-6">
        <label>Titolo</label>
        <InputText v-model="fileToUpload.title" type="text" class="inputfield w-full" />
        <div v-show="validationErrors.title && submitted" class="p-error">Campo richiesto.</div>
      </div>
      <div class="field col-12 md:col-6">
        <label>File</label>
        <div class="button-wrapper">
          {{fileToUpload.file.name}}
          <span :class="['label', {'active': fileToUpload.file.length > 0}]">
            {{fileToUpload.file.length > 0 ? fileToUpload.file[0].name : 'Seleziona File' }}
          </span>
          <input id="upload" type="file" ref="file" @change="handleFileUpload( $event )" :accept="`${Object.values(fileToUpload.allowedType).join(', ')}`" />
        </div>
        <div class="text-center allowed-format"> Formati consentiti: {{Object.keys(fileToUpload.allowedType).join(', ')}} </div>
        <div v-show="validationErrors.files && submitted" class="p-error">Campo richiesto.</div>
        <div v-show="validationErrors.type && submitted" class="p-error">Formato non consentito</div>
      </div>

      <div class="col-12 mt-4">
        <h6>Modulistica globale attualmente presente</h6>
          <DataTable :value="modulisticaGlobale" responsiveLayout="scroll">
            <Column field="titolo" header="Titolo"></Column>
            <Column field="tipo" header="Tipo"></Column>
            <Column field="data_inserimento" header="Data Inserimento">
              <template #body="{data}">
                {{formatDate(data.data_inserimento)}}
              </template>
            </Column>
            <Column :exportable="false" style="min-width:8rem">
                <template #body="slotProps">
                  <i @click="deleteModulo(slotProps.data)" class="pi pi-trash p-error cursor-pointer" ></i>
                </template>
            </Column>
            <Column :exportable="false" style="min-width:8rem">
                <template #body="slotProps">
                  <i @click="downloadModulo(slotProps.data)" class="pi pi-download text-primary cursor-pointer" ></i>
                </template>
            </Column>
        </DataTable>
      </div>
      
      </div>

  </div>
  <div class="wrap-footer-main-dialog">
    <div class="footer-main-dialog">
      <Button 
          label="Chiudi" 
          icon="pi pi-times"
          iconPos="right" 
          class="p-button-secondary mr-3"
          @click="onCancelButton($event)" 
        />
        <Button 
          label="Esegui" 
          icon="pi pi-check"
          iconPos="right" 
          class="mr-3"
          @click="onOkButton($event)" 
        />
    </div>
  </div>

</template>

<script>

import { ref, getCurrentInstance, onMounted} from 'vue';
import Service from '@/services/ask-operation/operation-service'
import AgentiService from '@/services/ask-management/agenti-service'
import Loader from '@/components/Loader.vue'
import { useToast } from "primevue/usetoast";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Loader
  },
    
  setup() {
    const page = { name: 'agenti-upload-modulistica'}
    const loader = ref(false)
    const toast = useToast();

    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const formatDate = self.appContext.config.globalProperties.$formatDate
    const service = new Service(self.$http, self.$eventBus)
    const agentiService = new AgentiService(self.$http, self.$eventBus)
    const fileToUpload = ref({
        title: '',
        file:[],
        allowedType : {
          'pdf' : 'application/pdf'
        }
    })
    const modulisticaGlobale = ref([])
    const validationErrors = ref({})
    const submitted = ref(false)
      
    onMounted(() =>{
      getModulisticaGlobale()
    })

    const getModulisticaGlobale = () => {
      loader.value = true
      service.getModulisticaGlobale(fileToUpload.value)
      .then((res) => {
        modulisticaGlobale.value = res.items
      })
      .finally(()=>{
        loader.value = false
      }) 
    }

    const handleFileUpload = (evt) => {
      fileToUpload.value.file = []
      evt.preventDefault()
      submitted.value = false;
      fileToUpload.value.file = self.refs.file.files
    }
      
    const onOkButton = () => {
      submitted.value = true;
      toast.removeGroup(page.name);
      if (validateForm() ) {
         
        loader.value = true
        service.uploadModulisticaGlobale(fileToUpload.value, null, 1)
        .then(() =>{
          getModulisticaGlobale()
        })
        .catch(() => {
          fileToUpload.value.file = []
          loader.value = false
          toast.add({severity:'error', summary: 'Attenzione', detail:'Errore caricamento file ', group: page.name});
        })
        .finally(()=>{
          fileToUpload.value.file = []
          loader.value = false
          self.$eventBus.emit(`dialog-return-ok-button`, {}) 
        })            

      }
    }
    
    const onCancelButton = () => {
       self.$eventBus.emit(`dialog-return-cancel-button`, {})
    }

    const deleteModulo = (modulo) => {
       loader.value = true
        agentiService.deleteAgenteModulo(
          modulo.codice,
        )
        .then((res) => {
          if (res.success) {
            toast.add({severity:'success', summary: 'Successo', detail:'Eliminato', group: page.name});
          } else {
            toast.add({severity:'error', summary: 'Errore', detail:'Errore', group: page.name});
          }
        })
        .finally(() => {
          loader.value = false
        })
    }

    const downloadModulo = (modulo) => {
      loader.value = true
      agentiService.downloadAgenteModulo(
        modulo.codice,
      )
      .finally(() => {
        loader.value = false
      })
    }


    const validateForm = () => {

      validationErrors.value = {}

      if (fileToUpload.value.title.length == 0)
        validationErrors.value['title'] = true;
      else
        delete validationErrors.value['title'];

      if (fileToUpload.value.file.length == 0) {
          validationErrors.value['files'] = true;
          delete validationErrors.value['type'];
      } else {
        delete validationErrors.value['files'];
      }


      if (fileToUpload.value.file.length > 0) {
        let valid = [...fileToUpload.value.file].every(file => [Object.values(fileToUpload.value.allowedType).join(', ')].includes(file.type), false);
        if (valid) 
          delete validationErrors.value['type'];
        else
          validationErrors.value['type'] = true;
      }

      return !Object.keys(validationErrors.value).length;
    }


    return {
      page,
      fileToUpload,
      modulisticaGlobale,
      loader,
      deleteModulo,
      downloadModulo,
      handleFileUpload,
      formatDate,
      validationErrors, 
      submitted,
      onCancelButton,
      onOkButton
    }
  }
}


</script>

<style scoped>
.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important; 
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform:uppercase;
  font-size:12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload {
    display: inline-block;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
}
</style>

